import { render } from "./CheckoutSucesso.vue?vue&type=template&id=89c51ab6"
import script from "./CheckoutSucesso.vue?vue&type=script&lang=js"
export * from "./CheckoutSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__